import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import formatMessage from 'format-message';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { List } from '@instructure/ui-list';
import noResultSrc from '../../../assets/svg/no_result.svg';

export default function NoResult ({
  title,
  message,
  imageUrl,
  imageSize,
  className,
  showSuggestions,
  ...rest
}) {
  className = classNames(className, 'No-result');

  return (
    <div {...rest} className={className}>
      <img
        className="No-result-image"
        src={imageUrl}
        alt=""
        role="presentation"
        style={{ maxHeight: imageSize }}
      />
      <h2 className="No-result-title">{title}</h2>
      {showSuggestions ? (
        <React.Fragment>
          <p className="No-result-message" role="status" aria-live="polite">
            {formatMessage('We couldn\'t find anything that match your search')}
          </p>
          <div className="No-result-suggestions">
            <View as="div" textAlign="center" margin="medium 0 small">
              <Text as="p" weight="bold">
                {formatMessage('Suggestions')}
              </Text>
            </View>
            <List margin="0">
              <List.Item>{formatMessage('Try removing or changing your filters')}</List.Item>
              <List.Item>{formatMessage('Try different keywords')}</List.Item>
              <List.Item>{formatMessage('Check spelling')}</List.Item>
              <List.Item>{formatMessage('Enter at least 3 letters in the search box')}</List.Item>
            </List>
          </div>
        </React.Fragment>
      ) : (
        message && <p className="No-result-message" role="status" aria-live="polite">{message}</p>
      )}
    </div>
  );
}

NoResult.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  imageUrl: PropTypes.string,
  imageHeight: PropTypes.number,
  showSuggestions: PropTypes.bool
};

NoResult.defaultProps = {
  imageUrl: noResultSrc,
  imageSize: 200,
  showSuggestions: false
};
